/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { TpConfigResolver } from "./guards/tp-config.resolver";
import { TP_DATA_RESOLVER_TP_CONFIG } from "./models/treatment-plan-constants";
import { MonitoringPage } from "./pages/monitoring/monitoring.page";
import { TpAdvancedPage } from "./pages/tp-advanced/tp-advanced.page";
import { TpBasePage } from "./pages/tp-base/tp-base.page";
import { TreatmentPlanPage } from "./pages/treatment-plan/treatment-plan.page";

const routes: Routes = [
  {
    path: "",
    redirectTo: "page",
    pathMatch: "full",
  },
  {
    // Main page
    path: "page",
    component: TreatmentPlanPage,
    // Load treatment plan scections configuration on tp access
    resolve: { [TP_DATA_RESOLVER_TP_CONFIG]: TpConfigResolver },
    children: [
      {
        path: "",
        redirectTo: "base",
        outlet: "treatment-plan",
        pathMatch: "full",
      },
      {
        path: "base",
        component: TpBasePage,
        outlet: "treatment-plan",
      },
      {
        path: "advanced",
        component: TpAdvancedPage,
        outlet: "treatment-plan",
      },
      {
        path: "monitoring",
        component: MonitoringPage,
        outlet: "treatment-plan",
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PatientTreatmentPlanRoutingModule {}
